import { Injectable } from '@angular/core';
import { Icon } from './icons.types';
import { feather, heroicons, material, iconsmind } from './iconpicker-data';
import { Observable, of } from 'rxjs';
import { cloneDeep } from 'lodash-es';

@Injectable({
    providedIn: 'root'
})
export class IconsService
{
    // Private
    private readonly _feather: any = feather;
    private readonly _heroicons: any = heroicons;
    private readonly _material: any = material;
    private readonly _iconsmind: any = iconsmind;

    private _icons: Icon[] = [{namespace: 'feather', name: 'Feather', grid: 'icon-size-6', list: cloneDeep(this._feather)}, 
    {namespace: 'heroicons_outline', name: 'Heroicons Outline', grid: 'icon-size-6', list: cloneDeep(this._heroicons)},
    {namespace: 'heroicons_solid', name: 'Heroicons Solid', grid: 'icon-size-5', list: cloneDeep(this._heroicons)},
    {namespace: 'iconsmind', name: 'Iconsmind', grid: 'icon-size-5', list: cloneDeep(this._iconsmind)},
    {namespace: 'mat_solid', name: 'Material Solid', grid: 'icon-size-6', list: cloneDeep(this._material)},
    {namespace: 'mat_outline', name: 'Material Outline', grid: 'icon-size-6', list: cloneDeep(this._material)},
    {namespace: '', name: 'Material Twotone', grid: 'icon-size-6', list: cloneDeep(this._material)}];

    /**
     * Constructor
     */
    constructor(){
    }

    ngOnInit(): void {
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for icons
     */
     get icons(): Observable<any>{
         return of(this._icons);
     }

    get nameSpaces(){
        return this._icons.map(icon => {
            return {namespace: icon.namespace, name: icon.name};
        });
    }

    getIcons(_nameSpace: string[]): Observable<any>
    {
        return of(this._icons.filter(icon => _nameSpace.includes(icon.namespace)));
    }
 
}